import styled from 'styled-components';

export const Container = styled.video`
  max-width: 101%;
`;
